// extracted by mini-css-extract-plugin
export default {"description":"updateFS_description__sJFpU","content":"updateFS_content__6gJe0"};